import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const AutoLoginPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [status, setStatus] = useState<'loading' | 'error'>('loading');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    // If already logged in, go to dashboard
    if (user) {
      navigate('/dashboard', { replace: true });
      return;
    }

    const key = searchParams.get('key');
    const email = searchParams.get('email');

    if (!key || !email) {
      setStatus('error');
      setErrorMsg('Missing key or email parameter');
      return;
    }

    const doLogin = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/auth/master-login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, masterKey: key }),
        });

        const data = await response.json();

        if (response.ok && data.success && data.data?.token) {
          // Store token and reload to let AuthContext pick it up
          localStorage.setItem('token', data.data.token);
          localStorage.setItem('authToken', data.data.token);
          window.location.href = '/dashboard';
        } else {
          setStatus('error');
          setErrorMsg(data.message || 'Login failed');
        }
      } catch (err) {
        setStatus('error');
        setErrorMsg('Connection error');
      }
    };

    doLogin();
  }, [searchParams, navigate, user]);

  if (status === 'error') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white p-8 rounded-xl shadow-lg text-center max-w-md">
          <div className="text-red-500 text-4xl mb-4">!</div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Login Failed</h2>
          <p className="text-gray-600 mb-6">{errorMsg}</p>
          <a href="/auth" className="text-blue-600 hover:underline">Go to login page</a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600 text-lg">Signing you in...</p>
      </div>
    </div>
  );
};
